import { configureStore } from "@reduxjs/toolkit";
import systemReducer from "@/features/systemSlice";
import dataTableReducer from "@/features/dataTableSlice";
import userReducer from "@/features/userSlice";

import workLocationManageReducer from "@/features/workLocationManageSlice";
import giveAwayManageReducer from "@/features/giveAwayManageSlice";
import dailyManageReducer from "@/features/dailyManageSlice";
import productSalesReducer from "@/features/productSalesSlice";

export default configureStore({
  reducer: {
    workLocationManage: workLocationManageReducer,
    user: userReducer,
    system: systemReducer,
    giveAwayManage: giveAwayManageReducer,
    daily: dailyManageReducer,
    dataTable: dataTableReducer,
    productSales: productSalesReducer,
  },
});
